import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/DashboardStyle.module.css';
import DashboardTitle from './DashboardTitle'
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";

const DashBoardMembership =()=>{
    return(<div><DashBoardLeftProfileMenu/>
        <div className={'containerStyla ' + Style.Dashboardscreen}>
<Container>
     <DashboardTitle title="Membership" membertype="" />
        <Row>
            <Col>
            <div className={Style.Memberstatus}>
                    <h3>Current Status :</h3>
                    <div className={Style.statusBox}>
                            <h4><img src="https://mayoalumni.in/images/non-member-img.png" alt=""/> Non Member</h4>
                    </div>
                </div>
            </Col>
        </Row>
        <Row>
       
                <Col lg={6}>
                    <div className={Style.aboutMembership}>
                        <h3>Become A Member</h3>
                        <p>As a member you only help MAAD cover its expenses but also enjoy special discounts and offers for events organized by MAAD.</p>
                    </div>
                </Col>
                <Col lg={6} className={Style.paddL}>
                    <div className={Style.memberCard}>
                        <img src="https://mayoalumni.in/images/life-member-card-img.png" alt=""  />
                    </div>
            </Col>
      
        </Row>
        <Row>
        
            <Col lg={6}>
                <div className={Style.payOffer}>
                        <div className={Style.box}>
                            <div className={Style.lSide}>
                                <h2>Life Membership</h2>
                                <p>Rs. 7500 (One Time)</p>
                            </div>
                            <div className={Style.rSide}>

                                    <button type="button" className={Style.greenBtn}>
                                        Pay Now
                                    </button>
                            </div>
                        </div>

                </div>
            </Col>
            <Col lg={6} className={Style.paddL}>
                <div className={Style.paymentOption}>
                    <h3>PAYMENT OPTIONS</h3>
                    <p>You will be given the option to select the payment option in the next screen</p>
                    <img className={Style.PaymentImg} src="https://mayoalumni.in/images/payment-img.png" alt=""  />
                    <img src="https://mayoalumni.in/images/card-img.png" alt=""/>
                </div>
            </Col>
       
        </Row>
    </Container>
    </div>
    </div>
    )
}
export default DashBoardMembership;